import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from "swiper/modules";
import 'swiper/css'; 
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from 'react-router-dom';

function TourGuideTwo() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch agents data from API
  useEffect(() => {
    const fetchAgents = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://dzsoftech.net/tours/api/airticket/agents/');
        if (!response.ok) {
          throw new Error('Failed to fetch agents data');
        }
        const data = await response.json();
        
        if (data.results && data.results.length > 0) {
          // Get active agents, prioritize featured ones
          const activeAgents = data.results
            .filter(agent => agent.is_active)
            .sort((a, b) => {
              if (a.featured && !b.featured) return -1;
              if (!a.featured && b.featured) return 1;
              return a.order - b.order;
            });
          setAgents(activeAgents);
        } else {
          // Use fallback data if no agents
          setAgents(getFallbackAgents());
        }
      } catch (err) {
        console.error('Error fetching agents:', err);
        setError(err.message);
        // Use fallback data on error
        setAgents(getFallbackAgents());
      } finally {
        setLoading(false);
      }
    };

    fetchAgents();
  }, []);

  // Fallback agents data if API fails
  const getFallbackAgents = () => {
    return [
      {
        id: 'fallback-1',
        name: 'Michel Smith',
        position: 'Tourist Guide',
        image_url: '/assets/img/team/team_img_1.jpg',
        facebook_url: 'https://facebook.com/',
        twitter_url: 'https://twitter.com/',
        linkedin_url: 'https://linkedin.com/',
      },
      {
        id: 'fallback-2',
        name: 'Sarah Johnson',
        position: 'Travel Expert',
        image_url: '/assets/img/team/team_img_2.jpg',
        facebook_url: 'https://facebook.com/',
        twitter_url: 'https://twitter.com/',
        linkedin_url: 'https://linkedin.com/',
      },
      {
        id: 'fallback-3',
        name: 'David Wilson',
        position: 'Tour Coordinator',
        image_url: '/assets/img/team/team_img_3.jpg',
        facebook_url: 'https://facebook.com/',
        twitter_url: 'https://twitter.com/',
        linkedin_url: 'https://linkedin.com/',
      }
    ];
  };

  // Function to get image URLs with fallbacks
  const getImageUrl = (agent, type = 'main') => {
    if (type === 'main') {
      return agent.image_url || '/assets/img/team/team_img_1.jpg';
    }
    // For background image, we'll use the same image or a fallback
    return agent.image_url || '/assets/img/team/team_1_1.jpg';
  };
  return (
    <section className="team-area3 position-relative bg-top-center space"
    style={{ backgroundImage: "url(/assets/img/bg/team_bg_2.jpg)", backgroundRepeat:"no-repeat", zIndex:"1", paddingBottom: "0" }}>
      <div className="container z-index-common">
        <div className="title-area text-center">
          <span className="sub-title">Meet with Guide</span>
          <h2 className="sec-title">Meet with Tour Guide</h2>
        </div>
        {loading ? (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="slider-area">
            <Swiper
              slidesPerView={3}
              spaceBetween={24}
              loop={agents.length > 3}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                576: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 3,
                },
              }}
              navigation={{
                prevEl: '.slider-prev',
                nextEl: '.slider-next',
              }}
              pagination={{ clickable: true }}
              modules={[Navigation, Pagination]}
              className="th-slider teamSlider3 has-shadow"
            >
              {agents.map((agent, index) => (
                <SwiperSlide key={agent.id || `agent-${index}`}>
                  <div className="th-team team-grid">
                    <div className="team-img">
                      <img 
                        src={getImageUrl(agent, 'main')} 
                        alt={agent.name} 
                        onError={(e) => {
                          e.target.src = '/assets/img/team/team_img_1.jpg';
                        }}
                      />
                    </div>
                    <div className="team-img2">
                      <img 
                        src={getImageUrl(agent, 'bg')} 
                        alt={agent.name} 
                        onError={(e) => {
                          e.target.src = '/assets/img/team/team_1_1.jpg';
                        }}
                      />
                    </div>
                    <div className="team-content">
                      <div className="media-body">
                        <h3 className="box-title">
                          <Link to={`/tour-guide/${agent.id}`}>{agent.name}</Link>
                        </h3>
                        <span className="team-desig">{agent.position}</span>
                        <div className="th-social">
                          {agent.facebook_url && (
                            <Link target="_blank" to={agent.facebook_url}>
                              <i className="fab fa-facebook-f" />
                            </Link>
                          )}
                          {agent.twitter_url && (
                            <Link target="_blank" to={agent.twitter_url}>
                              <i className="fab fa-twitter" />
                            </Link>
                          )}
                          {agent.linkedin_url && (
                            <Link target="_blank" to={agent.linkedin_url}>
                              <i className="fab fa-linkedin-in" />
                            </Link>
                          )}
                          {/* Always show some social media icons for design consistency */}
                          {!agent.facebook_url && !agent.twitter_url && !agent.linkedin_url && (
                            <>
                              <Link target="_blank" to="https://facebook.com/">
                                <i className="fab fa-facebook-f" />
                              </Link>
                              <Link target="_blank" to="https://twitter.com/">
                                <i className="fab fa-twitter" />
                              </Link>
                              <Link target="_blank" to="https://linkedin.com/">
                                <i className="fab fa-linkedin-in" />
                              </Link>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Slider Navigation */}
            <button className="slider-arrow slider-prev">
              <img src="/assets/img/icon/right-arrow2.svg" alt="" />
            </button>
            <button className="slider-arrow slider-next">
              <img src="/assets/img/icon/left-arrow2.svg" alt="" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default TourGuideTwo;
